import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseConfirmFiscalDocument {
  id: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

const useBillingFiscalDocumentGroupConfirmFiscalDocument = ({ id, onSuccess, onError }: UseConfirmFiscalDocument) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingFiscalDocumentGroupConfirmFiscalDocument', id],
    mutationFn: async () => {
      return await privateAxios.post(`/billing/fiscal_document_groups/${id}/confirm_fiscal_document`);
    },
    onSuccess,
    onError,
  });
};

export default useBillingFiscalDocumentGroupConfirmFiscalDocument;
